/**
 * Runtime config bootstrap. The same image works across staging/prod —
 * nginx's docker-entrypoint.sh substitutes __API_URL__ in index.html from
 * the pod env (API_URL) at container start.
 *
 * Detection chain:
 *   1. window.__STREAMKO_CONFIG__.apiUrl — production runtime, set by the
 *      inline script in index.html and substituted by nginx.
 *   2. import.meta.env.VITE_API_URL — `vite dev` fallback (no nginx in
 *      front, so the placeholder is left literal). Pulled from .env.
 *   3. '/api' — final fallback (admin originally defaulted to a relative
 *      `/api` path, preserved for back-compat in test contexts).
 *
 * If the placeholder is still literal (`__API_URL__`), treat it as not set
 * and fall through to the dev fallback.
 */

declare global {
  interface Window {
    __STREAMKO_CONFIG__?: { apiUrl?: string };
  }
}

export function getApiUrl(): string {
  if (typeof window !== 'undefined') {
    const cfg = window.__STREAMKO_CONFIG__?.apiUrl;
    if (cfg && !cfg.includes('__API_URL__')) return cfg;
  }
  return (import.meta.env.VITE_API_URL as string | undefined) ?? '/api';
}
